import { CustomModalProps } from '@common/types/common';
import { CloseButton } from '@components/utility/buttons';
import { DialogActions, DialogContent, DialogTitle, Dialog as MUIDialog } from '@mui/material';
import clsx from 'clsx';
import { useCallback } from 'react';

const Dialog = ({
    open,
    setOpen,
    children,
    header,
    actions,
    dialogClassName,
    width = 828,
    customCloseHandler,
}: CustomModalProps) => {
    const handleClose = useCallback(() => {
        if (customCloseHandler) {
            customCloseHandler();
        }
        setOpen(false);
    }, [setOpen, customCloseHandler]);

    return (
        <MUIDialog
            className={clsx(dialogClassName)}
            open={open}
            onClose={handleClose}
            disablePortal
            fullWidth
            slotProps={{
                backdrop: {
                    className: '-z-1',
                },

                paper: {
                    className: 'absolute flex flex-col rounded-2xl',
                    sx: {
                        width,
                        color: (theme) => theme.palette['neutral-900'].main,
                        boxShadow: 3,
                        minWidth: 'auto',
                    },
                },
            }}
        >
            <CloseButton className="absolute size-10 flex" color="black" onClick={() => handleClose()} />
            {header && <DialogTitle>{header}</DialogTitle>}
            <DialogContent dividers className="border-0 ">
                {children}
            </DialogContent>
            <DialogActions className="hidden md:flex px-6">{actions}</DialogActions>
        </MUIDialog>
    );
};

export { Dialog };
